<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    dark
    color="primary darken-1"
    width="272"
  >
    <!-- props: expand -->
    <v-list dense nav>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">masterTime</v-list-item-title>
          <v-list-item-subtitle class="mt-1">
            {{ company.title_th }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <div v-if="appMode === 'development'">
        <v-dialog v-model="dialogWebVersion" max-width="480">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mb-2"
              block
              small
              outlined
              color="white"
              v-bind="attrs"
              v-on="on"
            >
              v. 0.34.0 - 14/11/2025
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="text-h5 d-flex justify-space-between">
              <span>Web Versions - 0.34.0 14/11/2025</span>
              <v-btn icon @click="dialogWebVersion = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <h3 class="mb-2">Fix bug</h3>
              <ul>
                <li>เมนูประกาศ ขอข้อมลูพนักงาน Active</li>
                <li>เมนูจัดการกลุ่มสิทธิ ขอข้อมลูพนักงาน Active</li>
                <li>เมนูสิทธิ์ของพนักงาน ขอข้อมลูพนักงาน Active</li>
                <li>เมนูสิทธิ์การลงเวลานอกสถานที่ ขอข้อมลูพนักงาน Active</li>
                <li>เมนูสิทธิ์การลงเวลานอกสถานที่ Fix Error Limit</li>
                <li>เมนูบทบาท ขอข้อมลูพนักงาน Active</li>
                <li>แก้ไข Close Error Response Message</li>
                <li>เมนูองค์กร แก้ไข ขอข้อมูลองค์กร Error Limit</li>
                <li>เมนูองค์กร แก้ไข Root Organization Sort</li>
                <li>เมนูองค์กร แก้ไข Remove Select Data Organization</li>
                <li>เมนูพนักงาน แก้ไข Error Import Employee</li>
                <li>เมนู แก้ไข Menu Label (ข้อมูลทั่วไป เป็น ข้อมูลองค์กร)</li>
              </ul>
              <h3 class="mt-4 mb-2">New Feature</h3>
              <ul>
                <li>เมนูรายงาน 107 เพิ่มรายงานใหม่</li>
                <li>เมนูพนักงาน เพิ่ม Filter Shift, Employee-Type</li>
                <li>
                  เมนูพนักงาน ลงทะเบียนที่ Device Finger and Face Biometric
                </li>
                <li>เมนู Lock/Unlock เพิ่ม Filter Area, เพิ่ม Column Area</li>
                <li>เมนูองค์กร แก้ไข Organization Tree UI</li>
              </ul>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>

      <v-divider></v-divider>

      <v-list-item to="/" @click="onClickMenu(-1)">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>หน้าหลัก</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group
        v-for="(menu, index) in menus"
        :key="index"
        v-model="menu.active"
        :prepend-icon="menu.action"
        no-action
        color="white"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title v-text="menu.title"></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="subItem in menu.items"
          :key="subItem.title"
          :to="subItem.to"
          @click="onClickMenu(index)"
          :disabled="subItem.disabled"
        >
          <v-list-item-content>
            <v-list-item-title v-text="subItem.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>

    <template v-slot:append v-if="appVersion">
      <div class="px-4 py-2">
        <p class="mb-0" style="color: #ffffff; font-weight: bold">
          {{ appVersion }}
        </p>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'
import UIAccessController from '../assets/js/UIAccessController'

export default {
  data() {
    return {
      dialogWebVersion: false,
      appMode: process.env.VUE_APP_MODE,
      appVersion: process.env.VUE_APP_VERSION,
      menus: [],
    }
  },
  computed: {
    drawer: {
      // getter
      get: function () {
        return this.$store.state.drawer
      },
      // setter
      set: function (value) {
        // do something !
        this.$store.commit('SET_DRAWER', value)
      },
    },
    company() {
      return this.$store.state.authentication.company || { title_th: '' }
    },
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
  },
  watch: {
    uiCtrl(value) {
      if (value) {
        this.setMenus()
      }
    },
  },
  async created() {
    if (
      this.$store.state.authentication.authenticationStatus === 'authenticated'
    ) {
      const { admin, employee } = await this.me()

      if (admin) {
        const [ui_config, my_policies] = await Promise.all([
          this.fetchUiConfig(admin?.company?.company_uuid),
          this.fetchMyPolicies({
            policy_type: 'admin',
            uuid: admin?.admin_uuid,
          }),
        ])

        const uiCtrl = new UIAccessController(admin, ui_config, my_policies)
        this.$store.commit('SET_UI_CTRL', uiCtrl)
      }

      if (employee) {
        const [ui_config, my_policies] = await Promise.all([
          this.fetchUiConfig(employee?.company?.company_uuid),
          this.fetchMyPolicies({
            policy_type: 'employee',
            uuid: employee?.employee_uuid,
          }),
        ])

        const uiCtrl = new UIAccessController(employee, ui_config, my_policies)
        this.$store.commit('SET_UI_CTRL', uiCtrl)
      }

      this.setMenus()
    }
  },
  methods: {
    ...mapActions({
      me: 'authentication/me',
      fetchUiConfig: 'authentication/fetchUiConfig',
      fetchMyPolicies: 'authentication/fetchMyPolicies',
    }),
    onClickMenu(index) {
      sessionStorage.setItem('menu-active-index', index)
    },
    setMenus() {
      const data = [
        {
          action: 'mdi-widgets',
          title: 'ข้อมูลองค์กร',
          items: [
            { title: 'บริษัท', to: '/company', res: 'menu:::company' },
            {
              title: 'สถานที่ตั้งบริษัท',
              to: '/location',
              res: 'menu:::location',
            },
            {
              title: 'สถานที่ลงเวลานอกบริษัท',
              to: '/off-site-location',
              res: 'menu:::offsite_location',
            },
            { title: 'ปฏิทินวันหยุด', to: '/holiday', res: 'menu:::holiday' },
            {
              title: 'ประเภทพนักงาน',
              to: '/employee-type',
              res: 'menu:::employee_type',
            },
            {
              title: 'โครงสร้างองค์กร',
              to: '/organization',
              res: 'menu:::organization',
            },
            { title: 'ตำแหน่ง', to: '/position', res: 'menu:::position' },
            { title: 'กะทำงาน', to: '/shift', res: 'menu:::shift' },
            {
              title: 'ระดับพนักงาน',
              to: '/employee-level',
              res: 'menu:::employee_level',
            },
            { title: 'คำนำหน้าชื่อ', to: '/prefix', res: 'menu:::prefix' },
            {
              title: 'ประเภทการลา',
              to: '/leave-type',
              res: 'menu:::leave_type',
            },
            {
              title: 'ผู้อนุมัติลา',
              to: '/leave-approver',
              res: 'menu:::leave_approver',
            },
          ],
        },
        {
          action: 'mdi-account',
          title: 'จัดการพนักงาน',
          items: [
            { title: 'พนักงาน', to: '/employee', res: 'menu:::employee' },
            // {
            //   title: 'New พนักงาน',
            //   to: '/new-employee',
            //   res: 'menu:::new_employee',
            // },
            {
              title: 'สิทธิ์การลงเวลานอกสถานที่',
              to: '/time-attendance-off-site',
              res: 'menu:::time_attendance_offsite',
            },
            {
              title: 'ดาวน์โหลดข้อลูลการลา',
              to: '/leave-record/request/download',
              res: 'menu:::leave_record',
            },
          ],
        },
        {
          action: 'mdi-card-account-details',
          title: 'จัดการบัตร',
          items: [
            {
              title: 'บัตร',
              to: '/card',
              res: 'menu:::card_disabled',
            },
          ],
        },
        {
          action: 'mdi-tablet-cellphone',
          title: 'จัดการ Device',
          items: [
            { title: 'พื้นที่', to: '/area', res: 'menu:::area' },
            {
              title: 'รายการ Device',
              to: '/hardware-device',
              res: 'menu:::hardware_device',
            },
            {
              title: 'Lock / Unlock',
              to: '/lock-unlock',
              res: 'menu:::lock_unlock',
            },
          ],
        },
        {
          action: 'mdi-door-closed-lock',
          title: 'TA & Access',
          items: [
            {
              title: 'การจัดการ ช่วงเวลา',
              to: '/timezone',
              res: 'menu:::timezone',
            },
            {
              title: 'การจัดการ กลุ่ม Device',
              to: '/hardwares-group',
              res: 'menu:::hardware_group',
            },
            {
              title: 'การจัดการ กลุ่มพนักงาน',
              to: '/employees-group',
              res: 'menu:::employees_group',
            },
            // {
            //   title: 'การจัดการ กลุ่มสิทธิ์',
            //   to: '/rights-group',
            //   res: 'menu:::rights_group',
            // },
            {
              title: 'การจัดการ กลุ่มสิทธิ์',
              to: '/access-authority',
              res: 'menu:::access_authority',
            },
          ],
        },
        {
          action: 'mdi-text-box',
          title: 'รายงาน',
          items: [
            {
              title: '[101] บันทึกเวลา - รายบุคคล',
              to: '/report101',
              res: 'menu:::report101',
            },
            {
              title: '[102] บันทึกเวลา - มือถือ',
              to: '/report102',
              res: 'menu:::report102',
            },
            {
              title: '[103] บันทึกเวลา - คอลัมน์',
              to: '/report103',
              res: 'menu:::report103',
            },
            {
              title: '[104] บันทึกเวลา - อุณหภูมิ',
              to: '/report104',
              res: 'menu:::report104',
            },
            {
              title: '[105] บันทึกเวลา - (NFC)',
              to: '/report105',
              res: 'menu:::report105',
            },
            {
              title: '[106] บันทึกเวลา - (FILO)',
              to: '/report106',
              res: 'menu:::report106',
            },
            {
              title: '[107] บันทึกเวลา - มาสาย/กลับก่อน',
              to: '/report107',
              res: 'menu:::report107',
            },
          ],
        },
        {
          action: 'mdi-cog',
          title: 'ตั้งค่า',
          items: [
            {
              title: 'ประเภทบัตร',
              to: '/card-type',
              res: 'menu:::card_type',
            },
            { title: 'ประเภทการลงเวลา', to: '/duty', res: 'menu:::duty' },
            {
              title: 'จับคู่ประเภทการลงเวลา',
              to: '/duty-matching',
              res: 'menu:::duty_matching',
            },
            { title: 'ผู้ดูแลระบบ', to: '/admin', res: 'menu:::admin' },
            {
              title: 'การยืนยันตัวตนแบบ 2 ขั้นตอน',
              to: '/two-factor-auth',
              res: 'menu:::company_config:2fa_config',
            },
            {
              title: 'นโยบายรหัสผ่าน',
              to: '/password-policy',
              res: 'menu:::company_config:password_policy',
            },
            {
              title: 'Microsoft Entra ID',
              to: '/microsoft-entra-id',
              res: 'menu:::company_config:microsoft_entra_id',
            },
          ],
        },
        {
          action: 'mdi-tag-multiple',
          title: 'งานพิเศษ',
          items: [
            {
              title: 'ดาวน์โหลด Transaction',
              to: '/download-transaction',
              res: 'menu:::download_transaction',
            },
            {
              title: 'ดาวน์โหลด Transaction (NFC)',
              to: '/download-transaction-nfc',
              res: 'menu:::download_transaction_nfc',
            },
            {
              title: 'จัดการข้อมูลการลา',
              to: '/leave-file',
              res: 'menu:::leave:file',
            },
            {
              title: 'บันทึกกิจกรรม (Logs)',
              to: '/activity-log',
              res: 'menu:::activity-log',
            },
            {
              title: 'ส่งประกาศ',
              to: '/announcement',
              res: 'menu:::announcement',
            },
          ],
        },
        {
          action: 'mdi-monitor-dashboard',
          title: 'มอนิเตอร์',
          items: [
            {
              title: 'สถานะ Device',
              to: '/hardware-status',
              res: 'menu:::hardware_status',
            },
            {
              title: 'การใช้งาน Device',
              to: '/device-use',
              res: 'menu:::transaction_employee',
            },
          ],
        },
        {
          action: 'mdi-webhook',
          title: 'Webhook',
          items: [
            {
              title: 'Subscription',
              to: '/webhook-subscription',
              res: 'menu:::webhook:subscription',
            },
            {
              title: 'Developer Email',
              to: '/webhook-developer',
              res: 'menu:::webhook:developer',
            },
            {
              title: 'Resend Transaction',
              to: '/webhook-resend-transaction',
              res: 'menu:::webhook:resend-transaction',
            },
          ],
        },
        {
          action: 'mdi-lock',
          title: 'จัดการสิทธิ์การใช้งาน',
          items: [
            { title: 'บทบาท', to: '/user-role', res: 'menu:::user_role' },
            {
              title: 'สิทธิ์ของพนักงาน',
              to: '/employee-policy',
              res: 'menu:::employee_policy',
            },
          ],
        },
      ]

      this.menus = data
        .map((menu, index) => {
          const items = menu.items.filter((item) => {
            const result = this.uiCtrl.isEnable(item.res)

            // TODO: remove this condition after all menu is enabled
            // if (['menu:::new_employee'].includes(item.res)) {
            //   return item
            // }

            if (result) {
              return item
            }
          })

          if (items.length === 0) {
            return null
          }

          return {
            ...menu,
            items,
          }
        })
        .filter((menu) => menu !== null)

      const menuActiveIndex =
        sessionStorage.getItem('menu-active-index') || '-1'

      const hasActiveIndex = this.menus[menuActiveIndex]

      if (
        this.menus.length &&
        hasActiveIndex &&
        menuActiveIndex &&
        menuActiveIndex !== '-1'
      ) {
        this.menus[menuActiveIndex].active = true
      }
    },
  },
}
</script>
